import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

const AlingTextSideBySide = ({
  leftText,
  rightText,
  leftTextCaption,
  isPrimary,
  heading,
}: {
  leftText: string;
  rightText: string;
  leftTextCaption?: string;
  isPrimary?: boolean;
  heading?: boolean;
}) => (
  <Grid container mt={2}>
    <Grid item xs={6} textAlign="left">
      <WsTypography
        variant={heading ? WsTypoVariants.TITLE : WsTypoVariants.BODY1}
        bold
        color={isPrimary ? WsTypoColors.PRIMARY : WsTypoColors.BLACK}
      >
        {leftText}
      </WsTypography>
      {leftTextCaption && (
        <WsTypography bold variant={WsTypoVariants.BODY2} color={WsTypoColors.QUINARY}>
          {leftTextCaption}
        </WsTypography>
      )}
    </Grid>
    <Grid item xs={6} textAlign="right">
      <WsTypography
        bold
        variant={heading ? WsTypoVariants.TITLE : WsTypoVariants.BODY1}
        color={WsTypoColors.SECONDARY}
      >
        {rightText}
      </WsTypography>
    </Grid>
  </Grid>
);

export default AlingTextSideBySide;
